/* eslint-disable no-undef */
import { RouteComponentProps } from "@reach/router";
import * as React from "react";
import { Grid } from "@mui/material";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import MonitoringDeviceDetail from "../../components/Monitoring/MonitoringDeviceDetail";

interface Props extends RouteComponentProps {
    path?: string;
    deviceId?: string;
}

export default function MonitoringDevice({ deviceId }: Props) {
    return (
        <Grid container spacing={{ xs: 5, md: 6 }}>
            <Grid item xs={12}>
                <SectionTitle title={`Device Metrics for ${deviceId}`} align="left" showBottomBorder />
                <div style={{ marginTop: "22px" }}>{deviceId && <MonitoringDeviceDetail deviceId={deviceId} />}</div>
            </Grid>
        </Grid>
    );
}
